<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <div class="leftlogo">
      <p>
        <img src="../../../../styles/images/tclogo2.png" />
        <img src="../../../../styles/images/logomini.png" class="logomini" />
      </p>
    </div>
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item
        v-for="m in menu"
        :key="m.path"
        :item="m"
        :base-path="m.path"
      />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import SideBarMenu from "./SideBarMenu";
export default {
  props: {
    menu: Array,
  },
  // data() {
  //   console.log(this.menu, "index");
  //    return this.menu[0];
  // },
  components: { SidebarItem, SideBarMenu },
  computed: {
    ...mapGetters(["sidebar"]),
    // routes() {
    //   return this.$router.options.routes;
    // },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
<style scoped>
.leftlogo {
  width: 100%;
  height: 80px;
  background-color: rgb(48, 65, 86);
  padding: 5px 0;
}
.leftlogo p {
  text-align: center;
  padding-top: 5px;
}
.leftlogo img {
  text-align: center;
}
</style>
